import React, { useState } from 'react';
import '../style/applicationPolicy.css'
import FormGroupSelectInput from "./formGroupSelectInput";
import '../style/dots.css';
import FormResponseMessage from "./formResponseMessage";
import CustomModal from "./General/customModal";
import AdvancedDisbursementsFormHOC from "../containers/AdvancedDisbursements/advancedDisbursementsFormHOC";
import CenteredDots from "./General/centeredDots";
import {isAragUser} from "../helpers/functions";
import ChangeApplicationStatusModal from "./ApplicationPolicy/changeApplicationStatusModal";
import TransferApplicationBetweenSolicitorUsersModal from "./ApplicationPolicy/transferApplicationBetweenSolicitorUsersModal";
import PolicyTabs from "./ApplicationPolicy/policyTabs";
import ApplicationPolicyPageContent from "./ApplicationPolicy/applicationPolicyPageContent";
import {ApplicationPolicyViewHeader} from "./ApplicationPolicy/applicationPolicyViewHeader";
import '../style/mediaPrint.css'
import ApplicationPremiumSettingsHOC from '../containers/ApplicationPremiumSettings/applicationPremiumSettingsHOC';
import {NOT_FOUND_MESSAGE} from "../helpers/variables";
import CostsSummary from './ApplicationPolicy/costsSummary';
import { Alert } from 'arag-ui-lib';

const ApplicationPolicy = (props) => {
	const { UpdateTab,
		costsSummaryModal,
		toggleCostsSummaryModal,
		changeUpdatePolicyField } = props;
const [editingStaged,setEditingStaged]= useState(false)
    if(props.newApplication.fetchingSelectedApp){
        return (
            <CenteredDots/>
        )
    }
    if(!props.SelectedApp.id){
    	return (
    		<div className={'row'}>
                <FormResponseMessage Message={NOT_FOUND_MESSAGE} CenterWrapper="col-sm-12 mb-15" MessageStyle="formResponseMessage-reject" />
			</div>
		)
	}

	return (
		<div className="row print">
			{(isAragUser(props.User.loggedInUser.roles) && !props.Store.isPolicyLawsysFirmBankAccountValid) && (
				<FormResponseMessage
					Message={props.Store.checkLawsysFirmBankAccountValidityErrorMessage}
					CenterWrapper="col-sm-12"
					MessageStyle={props.Store.checkLawsysFirmBankAccountValidityErrorMessageBoxStyle}
				/>
			)}
            {
                props.Store.badResponsePatchNotification && (
                    <FormResponseMessage
                        LeftWrapper=""
                        CenterWrapper="col-sm-12"
                        MessageStyle="formResponseMessage-reject"
                        Message={props.Store.badResponsePatchNotification}
                    />
				)
            }
			{
				!!UpdateTab.costsSummaryError && UpdateTab.costsSummaryError.length > 0 && (
					<div className="col-sm-12">
						<Alert
							variant="error"
							label={UpdateTab.costsSummaryError}
							onDismiss={() => changeUpdatePolicyField('costsSummaryError', '')}
						/>
					</div>
				)
			}
			<CustomModal
				isOpen={props.Store.advancedDisbursementsApplicationModalOpen}
				content={<AdvancedDisbursementsFormHOC applicationId={props.SelectedApp.id} cancel={props._closeAdvancedDisbursementsApplicationModal} />}
				handleClose={props._closeAdvancedDisbursementsApplicationModal}
			/>

			<CostsSummary
				costsSummary={UpdateTab.costsSummary}
				costsSummaryModal={costsSummaryModal}
				toggleCostsSummaryModal={toggleCostsSummaryModal}
				selectedApp={props.SelectedApp}
			/>

			<div className="col-sm-12 applicationPolicy-wrapper">
				<CustomModal
					isOpen={props.Store.openModal && ((props.Store.selectedStatus === '' && (props.Store.selectedStatus === '')) || (props.Store.selectedStatus === 'Referred' && (props.Store.selectedReferredOptions === '')))}
					content={<div>
						<form className="form-horizontal">
							<FormGroupSelectInput
								Label="Change Status to"
								LeftWrapper="col-sm-3"
								Value={props.Store.selectedStatus}
								Name="selectedStatus"
								HandleInputChange={(evt) => {
									props.ChangeApplicationPolicySettings(evt.target.name, evt.target.value)
								}}
								Options={props.UserDropDownStatusOptions(props.SelectedApp.policyStatus, props.SelectedApp.referredToName?props.SelectedApp.referredToName:props.SelectedApp.roleGroupName,props.applicationAcceptedStatusesTransitions, props.SelectedApp.policyStatusMachineName)}
								CenterWrapper="col-sm-5 formGroupSelectInput-select-wrapper"
								RightWrapper="" Required={false}
								SelectStyle={'form-control formGroupSelectInput-select'}
							/>
						</form>
					</div>}
					handleClose={() => props.ChangeApplicationPolicySettings('openModal', false)}
				/>
				<CustomModal
					isOpen={props.Store.selectedStatus !== '' && !props.Store.openPremiumSettingsModal}
					content={ <ChangeApplicationStatusModal {...props}/>}
					handleClose={() => props.ChangeApplicationPolicySettings('selectedStatus', '')}
				/>
				<CustomModal
					contentClassname={'premiumSettingsWizard__modal'}
					isOpen={props.Store.openPremiumSettingsModal}
					content={<div>
						<ApplicationPremiumSettingsHOC
						isChangingStatusOfApp={true}
						showTable={!props.isEditingApplicationPremium}
						isEditMode={props.isEditingApplicationPremium}
						isApplicationPremium={true}
						applicationPremiumCancelHandler={props.isEditingApplicationPremium?props.cancelEditOfApplicationPremium:null}
						selectedApplicationCaseTypeId={props.SelectedApp.caseTypeId}
						onApplicationPremiumEdit={props.isEditingApplicationPremium?null:props.editApplicationPremium}
						onCancel={() => {props.ChangeApplicationPolicySettings('openPremiumSettingsModal', false) ;
						props.ChangeApplicationPolicySettings('premiumSettingsType','');
						props.ChangeApplicationPolicySettings('multipleAppPremiumSettingsFound',false);
						setEditingStaged(false);
						props.cancelEditOfApplicationPremium();
					}}
						isEditStaged={editingStaged}
						onEditStaged={() => setEditingStaged(!editingStaged)}
						/>
					</div>}
					handleClose={() =>{
                        props.cancelEditOfApplicationPremium();
						setEditingStaged(false);
						props.ChangeApplicationPolicySettings('premiumSettingsType','');
						props.ChangeApplicationPolicySettings('multipleAppPremiumSettingsFound',false);
					    props.ChangeApplicationPolicySettings('openPremiumSettingsModal', false);
					}}
				/>
				<CustomModal
					isOpen={props.Store.openTransferApplicationModal}
					content={ <TransferApplicationBetweenSolicitorUsersModal {...props}/>}
					handleClose={() => props.TransferApplicationBetweenSolicitorUsers('openTransferApplicationModal', false)}
				/>
				<div className="row">
					<h2 className="col-sm-12 applicationPolicy-h2">Application / Policy</h2>
				</div>
                <ApplicationPolicyViewHeader {...props}/>
				<div className="row">
					<div className="col-sm-12">
						<hr className=" applicationPolicy-hr"/>
					</div>
				</div>
                <PolicyTabs {...props}/>
                <ApplicationPolicyPageContent {...props}/>
			</div>
		</div>
	)
};

export default ApplicationPolicy;
